<template>
  <!-- BEGIN: Header -->
  <header id="m_header" class="m-grid__item m-header" :m-minimize-offset="200" :m-minimize-mobile-offset="200"
          :data-ts-loadingtxt="$t('common.LoadingDataPleaseWait')">
    <div class="m-container m-container--fluid m-container--full-height">
      <div class="m-stack m-stack--ver m-stack--desktop">

        <!-- BEGIN: Brand -->
        <div class="m-stack__item m-brand  m-brand--skin-dark ">
          <div class="m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-stack__item--middle m-brand__logo">
               <router-link :to="getLinkLogo"
                class="m-brand__logo-wrapper">
                   <img alt="logo" :src="cdn_url+'/img/logos/white.png'"/>
                </router-link>
            </div>
            <div class="m-stack__item m-stack__item--middle m-brand__tools">

              <!-- BEGIN: Left Aside Minimize Toggle -->
              <a href="javascript:" id="m_aside_left_minimize_toggle"
                 :ref="'sideMenuBtn'"
                 class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block  ">
                <span></span>
              </a>

              <!-- END -->

              <!-- BEGIN: Responsive Aside Left Menu Toggler -->
              <a href="javascript:" id="m_aside_left_offcanvas_toggle"
                 class="m-brand__icon m-brand__toggler m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                <span></span>
              </a>

              <!-- END -->

              <!-- BEGIN: Topbar Toggler -->
              <a id="m_aside_header_topbar_mobile_toggle" href="javascript:"
                 class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                <i class="flaticon-more"></i>
              </a>

              <!-- BEGIN: Topbar Toggler -->
            </div>
          </div>
        </div>
        <!-- END: Brand -->

        <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">

          <!-- BEGIN: Topbar -->
          <TopBar/>
          <!-- END: Topbar -->
        </div>
      </div>
    </div>
  </header>
  <!-- END: Header -->
</template>

<script>
  import TopBar from '@/components/dashboard/common/menus/TopBar'

  export default {
    data(){
      return {
        cdn_url: process.env.CDN_URL
      }
    },
    mounted() {
      this.$utils.checkSideBar()
    },
    components: {
      TopBar
    },
    computed: {
      getLinkLogo() {
        let queryCopy = this.$utils.cloneObject(this.$route.query)

        if (this.$route.name === 'Dashboard')
          return { name: 'Dashboard', query: queryCopy}


        return {name: 'Dashboard', query: {
          stats: 'tAgo'
          }}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/common/Header.vue